$(document).ready(function () {

  const IMAGE_STATE_CLASSES = ["platform-once", "platform-subscription", "platform-cards", "platform-cards2", "platform-causes"];
  const setPlatformImageState = (stateClass) => {
    $(".image-container.platform").removeClass(IMAGE_STATE_CLASSES.join(" ")).addClass(stateClass);
  };

  // Recurring selector always shows
  $("#recurring-radio-container").removeClass("d-none").addClass("d-flex");
  $("#recurring-radio-container").show();

  // Modify view to show available options
  const managePaymentOptionsWizoSubscription = () => {
    // Show/hide available options
    const selector = ".payment-selection .custom-control";
    $(`${selector}`).addClass("hidden-input");
    $(`${selector}.payment-clp.payment-once`).removeClass(
      "hidden-input"
    );
    $(".currency-selection").hide();
  };
  // Donation type selector
  $(".donation-type-select button").click(({ target }) => {
    var type = target.getAttribute("data-type");
    $("#recurring-radio-container").addClass("d-flex").removeClass("d-none");
    $(".invalid-amount").removeClass("d-none");
    $(".currency-selection").show();
    $(".wizo-subscription").hide();
    $(".wizo-subscription").prop('required', false);
    $("#subscription-wizo-header").hide();
    $("#subscription-wizo-label").hide();

    if (type === "wizo-subscription") {
      managePaymentOptionsWizoSubscription();
      $("#amount_form.dynamic-label label").text('Ingresa el monto de tu cuota social');
      $(".wizo-subscription").show();
      $(".wizo-subscription").prop('required', true);
      $(".single-donation").hide();
      $("#donator_email_label").html("Correo");
      $("#donator_email_fundraising").prop('required', true);
      $("#recurring-checkbox").prop("checked", false);
      $("#recurring-radio-container").hide();
      $(".app-container").show();
      $(".card-container").hide();
      $(".greeting-cards-banner").hide();
      $(".charity-wreaths-container").hide();
      $("#subscription-wizo-header").show();
      $("#subscription-header").hide();
      $("#once-header").hide();
      $("#subscription-wizo-label").show();
      $("#donator_donation_transactions_attributes_0_location_id").val(3243);
      $("#donator_donation_transactions_attributes_0_description").val('cuota social');
      setPlatformImageState("platform-subscription");
      $(".currency-selection label[data-currency='usd']").hide();
      $("#recurring-radio-container").removeClass("d-flex").addClass("d-none");
      $(".invalid-amount").addClass("d-none");
    } else if (type === "once") {
      $(".single-donation").show();
      $("#donator_email_label").html("Correo");
      $("#donator_email_fundraising").prop('required', true);
      $("#recurring-radio-container").show();
      $("#donator_donation_transactions_attributes_0_description").val('');
      setPlatformImageState("platform-once");
    } else if (type === "subscription") {
      $(".single-donation").show();
      $("#donator_email_label").html("Correo");
      $("#recurring-radio-container").show();
      $("#donator_donation_transactions_attributes_0_description").val('');
      setPlatformImageState("platform-subscription");
    }
  });

  $("[name='recurring_radio']").change((event) => {
    $("#recurring-radio-container").removeClass("d-none").addClass("d-flex");
    $("#recurring-radio-container").show();
  });

  // Wizo subscription validation
  $("#wizo-amount").change((event) => {
    $("#donator_donation_transactions_attributes_0_amount").val($("#wizo-amount").val())
  });
});
